<capra-breadcrumbs class="breadcrumbs"
  *ngIf="breadcrumbItems?.length"
  [breadcrumbs]="breadcrumbItems"
  [displayMode]="displayMode === DisplayMode.Menu ? 'menu' : 'dropdown'"
  (breadcrumbClicked)="onClick($event)"
></capra-breadcrumbs>
